import React from "react";
import { utils, writeFile } from "xlsx-js-style";
import CustomInput from "../components/formik/CustomInput";
import CustomSelect from "../components/formik/CustomSelect";

import { format } from "date-fns";
import { es } from "date-fns/locale";
import {
  getCurrentFortnightName,
  getOrderType,
  getReason,
} from "../models/ReportOperatorSalary";

const OrdersInvoicesReportForm = ({
  formik,
  records,
  status,
  paymentTypes,
  invoices,
}) => {
  const exportToExcel = () => {
    const workbook = utils.book_new();
    const sheetName = "Facturas";
    const headerStyle = { fill: { fgColor: { rgb: "DDEBF7" } } };
    const rowStyle = { fill: { fgColor: { rgb: "53ff00" } } };
    const totalStyle = { fill: { fgColor: { rgb: "FFF2CC" } } };

    const sheetData = [
      [
        { t: "s", v: "Folio orden", s: headerStyle },
        { t: "s", v: "Factura generada por", s: headerStyle },
        { t: "s", v: "Plataforma", s: headerStyle },
        { t: "s", v: "Tipo de Servicio", s: headerStyle },
        { t: "s", v: "Fecha de Factura", s: headerStyle },
        { t: "s", v: "Tipo de Pago", s: headerStyle },
        { t: "s", v: "Monto", s: headerStyle },
      ],
    ];

    let totalAmount = 0;
    const baseUrl = window.location.origin;

    invoices.forEach((invoice) => {
      const orderId = invoice.order_id || invoice.orderVial_id;

      const folio =
        invoice.Order?.folio ??
        invoice.OrderVial?.folio ??
        (orderId ? orderId.toString().padStart(5, "0") : "N/A");

     let tipoServicio;
            if (invoice.tipo === "Varo Express") {
              tipoServicio =
                invoice.OrderVial?.typeService?.type_service_name ?? "N/A";
            } else {
              if (invoice.Order?.typeService?.type_service_name) {
                tipoServicio = invoice.Order.typeService.type_service_name;
              } else if (invoice.Order) {
                tipoServicio = getOrderType(invoice.Order);
              } else {
                tipoServicio = "N/A";
              }
            }

      const tipoPlataforma = invoice.tipo ?? "Desconocido";

      const fechaFactura = invoice.invoice_date
        ? format(new Date(invoice.invoice_date), "dd/MMM/yyyy", { locale: es })
        : "N/A";

      const tipoPago = invoice?.PaymentType?.payment_type_name || "N/A";

      const monto = Number(invoice.invoice_amount) || 0;

      const creadoPor = invoice.creator_invoice
        ? `${invoice.creator_invoice.name} ${invoice.creator_invoice.first_surname}`
        : "N/A";

      sheetData.push([
        {
          t: "s",
          v: folio,
          l: {
            Target:
              tipoPlataforma === "Varo Express"
                ? `${baseUrl}/orders-vial/editOrder/${orderId}`
                : `${baseUrl}/orders/edit/${orderId}`,
          },
          s: rowStyle,
        },
        { t: "s", v: creadoPor, s: rowStyle },
        { t: "s", v: tipoPlataforma, s: rowStyle },
        { t: "s", v: tipoServicio, s: rowStyle },
        { t: "s", v: fechaFactura, s: rowStyle },
        { t: "s", v: tipoPago, s: rowStyle },
        { t: "n", v: monto, s: rowStyle },
      ]);

      totalAmount += monto;
    });

    sheetData.push([{ t: "s", v: "" }]); // Fila vacía

    sheetData.push([
      { t: "s", v: "Total", s: totalStyle },
      { t: "s", v: "", s: totalStyle },
      { t: "s", v: "", s: totalStyle },
      { t: "s", v: "", s: totalStyle },
      { t: "s", v: "", s: totalStyle },
      { t: "s", v: "", s: totalStyle },
      { t: "n", v: totalAmount, s: totalStyle },
    ]);

    const worksheet = utils.aoa_to_sheet(sheetData);
    worksheet["!cols"] = [
      { wch: 15 }, // Folio orden
      { wch: 30 }, // Generada por
      { wch: 20 }, // Plataforma
      { wch: 25 }, // Tipo de Servicio
      { wch: 20 }, // Fecha
      { wch: 20 }, // Tipo de Pago
      { wch: 15 }, // Monto
    ];

    utils.book_append_sheet(workbook, worksheet, sheetName);
    writeFile(workbook, "Facturas_" + getCurrentFortnightName() + ".xlsx");
  };

  return (
    <React.Fragment>
      <div className="row align-items-end gx-1">
        {/* inputs de rango de fecha de facturas */}
        <CustomInput
          label="Factura desde"
          field="start"
          type="date"
          formik={formik}
          sm={3}
        />
        <CustomInput
          label="Factura hasta"
          field="end"
          type="date"
          formik={formik}
          sm={3}
        />

        <CustomSelect
          label="Tipo de pago"
          field="paymentTypes"
          formik={formik}
          options={paymentTypes}
          required
          sm={2}
        />

        <CustomSelect
          label="Plataforma"
          field="companyType"
          formik={formik}
          options={[
            { value: "all", label: "Todas" },
            { value: "Gruas Varo", label: "Gruas Varo" },
            { value: "Varo Express", label: "Varo Express" },
          ]}
          required
          sm={2}
        />

        <div className="col-sm-2 d-flex gap-2">
          <button
            className="btn btn-primary w-50"
            onClick={() => formik.handleSubmit()}
          >
            <i className="fa-solid fa-magnifying-glass" />
            &nbsp;Buscar
          </button>
          <button
            className="btn btn-success w-50"
            onClick={() => exportToExcel()}
          >
            <i className="fa-solid fa-file-excel" />
            &nbsp;Descargar
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrdersInvoicesReportForm;
